import filesApi from '.'
import { getAuthHeaders } from 'utils/requests'

const deleteFile = async (id) => {
  const headers = { headers: getAuthHeaders() }
  return await filesApi.delete(`/${id}`, headers)
}

export default deleteFile
